module.exports = __webpack_public_path__ + "static/media/pwa_badge_ru_color_40.95bb451a.svg";